import React, { Component } from "react";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LocaleUtil } from "@eres/core";
import { LVStrings } from "@my-dld/assets/strings";


export interface IPageContext {
	title: string;
	paths?: PathInfo[];
	hideBreadCrumb?: boolean;
	setTitle: ( title?: LocaleValue | string ) => void;
	setPaths: ( paths?: PathInfo[] ) => void;
	showBreadCrumb: ( value: boolean ) => void;
}

export interface PathInfo {
	path?: string;
	id: string;
	label: LocaleValue;
}

const defaultContext: IPageContext = {
	title: "",
	paths: [],
	setTitle: title => {
	},
	setPaths: paths => {
	},
	showBreadCrumb: value => {
	}
};

export const PageContext = React.createContext( defaultContext );

interface State extends IPageContext {

}

interface Props {

}

class PageContextWrapper extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			...defaultContext,
			setPaths: this.setPaths,
			setTitle: this.setTitle,
			showBreadCrumb: this.showBreadCrumb,
		};
	}

	setTitle = ( title?: LocaleValue | string ) => {
		this.setState( {
			title: title ? LocaleUtil.getLocalValue( title ) : undefined,
		} );
	};
	setPaths = ( paths?: PathInfo[] ) => {
		this.setState( { paths: paths } );
	};
	showBreadCrumb = ( value: boolean ) => {
		this.setState( { hideBreadCrumb: value == false } );
	};

	render() {
		const { children, ...props } = this.props;
		return <PageContext.Provider value={ this.state }>
			{ children }
		</PageContext.Provider>;
	}
}

export default PageContextWrapper;


export const DashboardBCItem: PathInfo = {
	path: "/mydld",
	label: LVStrings.my_portfolio,
	id: "mydashboard"
};
export const MyRequestsBCItem: PathInfo = {
	path: "/mydld/dashboard",
	label: LVStrings.my_requests,
	id: "my_requests"
};
export const MyProfileBCItem: PathInfo = {
	path: "/mydld/profile",
	label: LVStrings.my_profile,
	id: "my_profile"
};
export const MyTenancyRequestsBCItem: PathInfo = {
	path: "/mydld/my_tenancy_requests",
	label: LVStrings.my_tenancy_requests,
	id: "my_tenancy_requests"
};
export const RequestsFromTenantBCItem: PathInfo = {
	path: "/mydld/requests_from_tenant",
	label: LVStrings.requests_from_tenant,
	id: "requests_from_tenant"
};
export const LeaseDetailsBCItem: PathInfo = {
	path: "/mydld/my_leases",
	label: LVStrings.i_am_tenant,
	id: "my_leases"
};
export const HTRequestsBCItem: PathInfo = {
	path: "/mydld/hand_take_over/requests",
	label: LVStrings.handover_takeover_requests,
	id: "handover_takeover_requests"
};

export const TabuPropertyBCItem = ( pType: string, pId: string ) => {
	return {
		path: `/mydld/property/${ pType }/${ pId }`,
		label: LVStrings.property_details,
		id: "property_details"
	} as PathInfo;
};
export const TabuEjariBCItem = ( pType: string, pId: string ) => {
	return {
		path: `/mydld/property/${ pType }/${ pId }/ejarisvc/details`,
		label: LVStrings.ejari_services,
		id: "ejari_services"
	} as PathInfo;
};
